import { Component, signal, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavbarComponent } from "@shared/navbar/navbar.component";
import { Footer } from "@shared/footer/footer";
import { ToastComponent } from "@shared/toast/toast.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, Footer, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('communitysupermart26v10.client');
}
